<div class="map-controls">
  <div matTooltip="Zoom In" matTooltipShowDelay="250" matTooltipPosition="left" (click)="zoom()" tabindex="0" (keyup.enter)="zoom()">
    <mat-icon>add</mat-icon>
  </div>
  <div matTooltip="Zoom Out" matTooltipShowDelay="250" matTooltipPosition="left" (click)="zoom(-1)" tabindex="0" (keyup.enter)="zoom(-1)">
    <mat-icon>remove</mat-icon>
  </div>
  <div matTooltip="Exort as PNG" matTooltipShowDelay="250" matTooltipPosition="left" (click)="exportAsPng()" tabindex="0" (keyup.enter)="exportAsPng()">
    <mat-icon>download</mat-icon>
  </div>
  <div class="zoom-to-point" [class.active]="mapService.pointSelectionActive" (click)="togglePointSelection()"
       matTooltip="Zoom To Point" [matTooltipDisabled]="mapService.pointSelectionActive" matTooltipShowDelay="250"
       matTooltipPosition="left" tabindex="0" (keyup.enter)="togglePointSelection()">
    <mat-icon>location_searching</mat-icon>
  </div>
</div>


<!-- Hidden Controls:: Add control buttons above-->
<form class="coordinate-box hide" [formGroup]="coordinateGroup" [class.show]="mapService.pointSelectionActive">

  <mat-form-field appearance="outline" subscriptSizing="dynamic" floatLabel="always">
    <mat-label>Latitude</mat-label>
    <input matInput placeholder="ex. 38.54" formControlName="latitude">
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic" floatLabel="always">
    <mat-label>Longitude</mat-label>
    <input matInput placeholder="ex. -86.12" formControlName="longitude">
  </mat-form-field>

  <button color="primary" mat-flat-button [disabled]="coordinateGroup.invalid" (click)="goToPoint()">Search</button>

</form>

